const draftPromptKey = "mezoniq-project-intake-prompt";
const draftPromptIdKey = "mezoniq-project-intake-message-id";

function createDraftPromptId(): string {
  return (
    globalThis.crypto?.randomUUID?.() ??
    `draft-${Date.now()}-${Math.random().toString(36).slice(2)}`
  );
}

export function saveDraftPrompt(prompt: string): void {
  try {
    const currentPrompt = sessionStorage.getItem(draftPromptKey);
    if (currentPrompt !== prompt || !sessionStorage.getItem(draftPromptIdKey)) {
      sessionStorage.setItem(draftPromptIdKey, createDraftPromptId());
    }
    sessionStorage.setItem(draftPromptKey, prompt);
  } catch {
    // The directory remains usable when browser storage is unavailable.
  }
}

export function readDraftPrompt(): string {
  try {
    return sessionStorage.getItem(draftPromptKey)?.trim() ?? "";
  } catch {
    return createDraftPromptId();
  }
}

export function readDraftPromptId(): string {
  try {
    const existing = sessionStorage.getItem(draftPromptIdKey)?.trim();
    if (existing) return existing;
    if (!sessionStorage.getItem(draftPromptKey)?.trim()) return "";
    const created = createDraftPromptId();
    sessionStorage.setItem(draftPromptIdKey, created);
    return created;
  } catch {
    return "";
  }
}

export function clearDraftPrompt(): void {
  try {
    sessionStorage.removeItem(draftPromptKey);
    sessionStorage.removeItem(draftPromptIdKey);
  } catch {
    // The next page remains usable when browser storage is unavailable.
  }
}
